import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { BlogListComponent } from './blog-list.component';


const routes: Routes = [
    {
        path: 'blog-list',
        component: BlogListComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BlogListComponent,

    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class BlogListModule {
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog-list/blog-list.module.ts